import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const deviceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRequests: builder.query({
      query: (sptId) => {
        return {
          url: `/devices/${sptId}/requests`,
        }
      },
      providesTags: (result, error, arg) => [{ type: 'Request', id: arg }],
    }),
  }),
  overrideExisting: false
})

export const {
  useGetRequestsQuery
} = deviceApiSlice
